import http from '@/services/http';
import axios from 'axios';
import { error, info } from '@/utils/safetyLog';
import {
  promotionBannerUrlMap,
  popupBannerUrlMap,
  mulPopupBannerUrlMap,
  mulPopupBannerContenttypeUidMap,
} from '@/utils/constants';

const APP_BASE_URL = process.env.NEXT_PUBLIC_APP_BASE_URL;
const defaultLanguage = 'zh-hk';

export const getEntryByContentTypeUrl = async (
  contentType: string,
  url: string,
  includeReference?: any,
  localLanguage: string = defaultLanguage,
) => {
  const endpoint = `/contentstack/${contentType}/`;
  const payload = {
    queryObj: { url },
    language: localLanguage,
    includeReference,
  };
  try {
    const response = await http({}).post(endpoint, payload);
    return response;
  } catch (e) {
    error(
      'getEntryByContentTypeUrl error:',
      { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload },
      e,
    );
    return null;
  }
};

export const getEntryByContentTypeAndEntry = async (
  contentType: string,
  entry: string,
  includeReference?: string[],
) => {
  const endpoint = `/contentstack/${contentType}/${entry}`;
  const payload = {
    includeReference: includeReference || [],
    defaultLanguage,
  };
  try {
    const res = http({}).post(endpoint, payload);
    return res;
  } catch (e) {
    error(
      'getEntryByContentTypeAndEntry error:',
      { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload },
      e,
    );
    return null;
  }
};

export const getPromotionBanner = async (pathname: string, localLanguage: string = defaultLanguage) => {
  const endpoint = '/banner/shared_banner_modal';
  const payload = {
    language: localLanguage,
    includeReference: [],
    targetUrl: promotionBannerUrlMap[pathname],
  };
  try {
    const response = await http({}).post(endpoint, payload);
    return response;
  } catch (e) {
    error('getPromotionBanner error:', { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload }, e);
    return null;
  }
};

export const getPopupBanner = async (pathname: string, localLanguage: string = defaultLanguage) => {
  const endpoint = '/banner/pop_up_modal';
  const payload = {
    language: localLanguage,
    includeReference: [],
    targetUrl: popupBannerUrlMap[pathname],
  };
  try {
    const response = await http({}).post(endpoint, payload);
    return response;
  } catch (e) {
    error('getPopupBanner error:', { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload }, e);
    return null;
  }
};

export const getMultiplePopupBanner = async (
  pathname: string,
  localLanguage: string = defaultLanguage,
  articleUrl?: string,
) => {
  const url = articleUrl ? `/${articleUrl}/` : '';
  const queryObj = url === '/undefined/' ? {} : { url };
  const endpoint = `/banner/shared_blog_pop_up_modal/${mulPopupBannerContenttypeUidMap[pathname]}`;
  const payload = {
    queryObj,
    language: localLanguage === 'en-us' ? 'en-us' : defaultLanguage,
    targetUrl: mulPopupBannerUrlMap[pathname],
  };
  try {
    const response = await http({}).post(endpoint, payload);
    return response;
  } catch (e) {
    error('getMultiplePopupBanner error:', { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload }, e);
    return { data: [] };
  }
};

export const getFeatureConfig = async () => {
  const payload = {
    language: 'en-us',
    queryObj: {},
  };
  const endpoint = '/contentstack/Feature_Config';
  try {
    const response = await http({}).post(endpoint, payload);
    return response;
  } catch (e) {
    error('getFeatureConfig error:', { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload }, e);
    return null;
  }
};

export const getBlogFeatureConfig = async () => {
  const endpoint = '/contentstack/blog_feature_config/blt6963ea3b5da6c2f7';
  const payload = {
    language: 'en-us',
    queryObj: {},
  };
  try {
    const response = await http({}).post(endpoint, payload);
    return response;
  } catch (e) {
    error('getBlogFeatureConfig error:', { httpEndpoint: http({}).defaults.baseURL + endpoint, payload: payload }, e);
    return null;
  }
};
